import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HeroSection from '../components/sections/HeroSection';
import FeaturesBar from '../components/sections/FeaturesBar';
import ProductCollection from '../components/sections/ProductCollection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Testimonials from '../components/sections/Testimonials';
import ReachUs from '../components/sections/ReachUs';
import ProductsList from '../components/pages/ProductsList';
import ProductViewPage from '../components/pages/ProductView';
import CartPage from '../components/pages/CartPage';
import AboutPage from '../components/pages/AboutUs';
import CheckoutPage from '../components/pages/CheckoutPage';
// import SizeGuidePage from './components/sections/SizeGuide';
import OrderSuccessPage from '../components/pages/OrderSuccessPage';

const AppRoutes = ({ onAddToCart }) => {
  return (
    <Routes>
      {/* Landing page */}
      <Route
        path="/"
        element={
          <>
            <HeroSection />
            <FeaturesBar />
            <ProductCollection onAddToCart={onAddToCart} />
            <WhyChooseUs />
            <Testimonials />
            <ReachUs />
          </>
        }
      />

      {/* Category pages */}
      <Route path="/all"    element={<ProductsList category="all"    onAddToCart={onAddToCart} />} />
      <Route path="/men"    element={<ProductsList category="men"    onAddToCart={onAddToCart} />} />
      <Route path="/women"  element={<ProductsList category="women"  onAddToCart={onAddToCart} />} />
      <Route path="/unisex" element={<ProductsList category="unisex" onAddToCart={onAddToCart} />} />
      <Route path="/sale"   element={<ProductsList category="all"    onAddToCart={onAddToCart} sale />} />

      {/* Cart and checkout flow */}
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-success" element={<OrderSuccessPage />} />
      <Route path="/about" element={<AboutPage />} />
      {/* <Route path="/size-guide" element={<SizeGuidePage />} /> */}
      {/* Single product view */}
      <Route path="/product/:productId" element={<ProductViewPage />} />
    </Routes>
  );
};

export default AppRoutes;